export const ItemType = 'sdgItem';
